import { render, staticRenderFns } from "./PartnerDialog.vue?vue&type=template&id=64c422b2&scoped=true&"
import script from "./PartnerDialog.vue?vue&type=script&lang=js&"
export * from "./PartnerDialog.vue?vue&type=script&lang=js&"
import style0 from "./PartnerDialog.vue?vue&type=style&index=0&id=64c422b2&prod&scoped=true&lang=css&"
import style1 from "./PartnerDialog.vue?vue&type=style&index=1&id=64c422b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c422b2",
  null
  
)

export default component.exports